function clientHeaderDirective() {
	return {
		scope : {
			idClient: '=',
			idSite: '=?',
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/clientHeaderDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'clientService', function($scope, $window, alertService, clientService) {
			$scope.client = null;
			$scope.site = null;

			$scope.loadClient = function(idClient) {
				clientService.getClientBasicInfo(idClient).then(function(response) {
					$scope.client = response.getData();
                }, function(response) {
                	//on error
                });
			};
			
			$scope.loadSite = function(idClient, idSite) {
				if(idClient && idSite){
					clientService.getClientSite(idClient, idSite).then(function(response) {
						$scope.site = response.getData();
	                }, function(response) {
	                	//on error
	                });
				}
			};
			
			$scope.loadClient($scope.idClient);
			$scope.loadSite($scope.idClient, $scope.idSite);

		} ],
		link : function(scope, elem, attr) {
			
		}
	};
};

module.directive('clientHeader', [ clientHeaderDirective ]);